/* eslint-disable react/jsx-key */
import React, { Fragment } from 'react';
import FilterVector from '@/assets/images/svg/FilterVector';
import { DropdonwFlags, Loading } from '@/components';
import { Container, Label } from 'reactstrap';
import { ReactComponent as Detail } from '@/assets/images/svg/detail.svg';
import { ReactComponent as Comment } from '@/assets/images/svg/comment.svg';
// import { ReactComponent as X } from '@/assets/images/svg/x.svg';
// import { ReactComponent as Transfer } from '@/assets/images/svg/transfer.svg';
import { ActionProps, Dialog } from '@/components/Dialog';
import { CustomTable } from '@/components/Table';
import Pagination from '@/components/Utils/Pagination';
import { FormErrors, OnChangeFormInput, FormData } from '@/hooks/useForm';
import { FilterContent } from '@/features/ticket/components/FilterContent';
import { updateMask as updateMaskCPF } from '@/helpers/masks/cpf';
import OrderTicket from '@/model/OrderTicket';
import { TicketCommentController, TicketRequestParams } from '@/features/ticket/types';
import dayjs from 'dayjs';
import formatValueToCurrency from '@/helpers/common/mask';
import OrderPayment from '@/model/OrderPayment';
import PaymentType from '@/model/PaymentType';
import StatusType from '@/model/StatusType';
import PaymentStatus from '@/model/PaymentStatus';
import { RegisterCommentContent } from '@/features/ticket/components/RegisterCommentContent';
import { TicketDetailContent } from '@/features/ticket/components/TicketDetailContent';
import OrderTicketDetail from '@/model/OrderTicketDetail';
import { Link } from 'react-router-dom';
import { ArrowLeft, Copy } from 'react-feather';
import { colors } from '@/styles/colors';
import { toast } from 'react-toastify';
import { FaFilePdf, FaQrcode } from 'react-icons/fa';
import QRCode from 'react-qr-code';
import { columns } from './table';

// eslint-disable-next-line no-shadow
export enum States {
  default = 'default',
  loading = 'loading',
}

interface DataColumn {
  id: string;
  name: string;
}

export interface DataRow {
  id: string | React.ReactNode;
  pdvName: string;
  sectionAndTicket: string;
  cpf: string;
  saleDate: string;
  paymentStatus: string | React.ReactNode;
  saleValue: string;
  paymentType: string | React.ReactNode;
  transaction: string | React.ReactNode;
  actions: string | React.ReactNode;
}

// eslint-disable-next-line no-shadow
export enum ShouldShowModal {
  filter = 'filter',
  comment = 'comment',
  detail = 'detail',
  qrcode = 'qrcode',
}

interface StateProps {
  state: States;
  title: string | React.ReactNode;
  visible: boolean;
  shouldShowModal: ShouldShowModal;
  listTickets: OrderTicket[];
  currentPage: TicketRequestParams;
  formDataFilter: FormData;
  formErrorsFilter: FormErrors;
  controllerComment: TicketCommentController;
  ticketDetail: OrderTicketDetail;
  orderTicket?: OrderTicket;
}

interface DispatchProps {
  onToggle: () => void;
  onPaginationChange: (page: number) => void;
  onChangeFormInputFilter: OnChangeFormInput;
  onShowReversePayment: (orderTicket: OrderTicket) => void;
  onShowCancelTicket: (orderTicket: OrderTicket) => void;
  onFilter: () => Promise<void>;
  clearFilter: () => void;
  event: any;
  onShouldShowModal: ({
    value,
    newTitleModal,
    orderTicket,
  }: {
    value: ShouldShowModal;
    newTitleModal: string | React.ReactNode;
    orderTicket?: OrderTicket;
  }) => void;
}

type Props = StateProps & DispatchProps;

export const TicketContainer: React.FC<Props> = ({
  state,
  listTickets,
  currentPage,
  title,
  visible,
  shouldShowModal,
  formDataFilter,
  formErrorsFilter,
  controllerComment,
  ticketDetail,
  orderTicket,
  event,
  clearFilter,
  onPaginationChange,
  onChangeFormInputFilter,
  onToggle,
  onFilter,
  // onShowReversePayment,
  // onShowCancelTicket,
  onShouldShowModal,
}) => {
  const getClassName = (isRed: boolean): string => {
    let className = 'mr-4 svg-icon action-icon';
    if (isRed) {
      className = 'mr-4 svg-icon-error action-icon';
    }
    return className;
  };
  const fromStatusType = (statusType: StatusType): JSX.Element => {
    let s = <div></div>;
    switch (statusType) {
      case StatusType.ACTIVE:
        s = <div className="flag-item text-active action-icon">Aprovado</div>;
        break;
      case StatusType.INACTIVE:
        s = <div className="flag-item text-inactive action-icon">Cancelado</div>;
        break;
      default:
        s = <div className="flag-item text-inactive action-icon">Extornado</div>;
        break;
    }
    return s;
  };

  const fromPaymentStatus = (paymentStatus: PaymentStatus): JSX.Element => {
    let s = <div></div>;
    switch (paymentStatus) {
      case PaymentStatus.APPROVED:
        s = <div className="flag-item text-active action-icon">Aprovado</div>;
        break;
      case PaymentStatus.DISAPPROVED:
        s = <div className="flag-item text-inactive action-icon">Reprovado</div>;
        break;
      case PaymentStatus.AWAITING_PAYMENT:
        s = <div className="flag-item text-await action-icon">Aguardando Pagamento</div>;
        break;
      case PaymentStatus.CANCELED:
        s = <div className="flag-item text-inactive action-icon">Cancelado</div>;
        break;
      case PaymentStatus.CANCELLATION_ANALYSIS:
        s = (
          <div className="flag-item text-processing action-icon">
            Aguardando analise do cancelamento
          </div>
        );
        break;
      default:
        s = <div></div>;
        break;
    }
    return s;
  };

  const fromPaymentType = (paymentType: PaymentType, installments: number): string => {
    let s = '';
    switch (paymentType) {
      case PaymentType.CREDIT_CARD:
        s = `Cartão de crédito ${installments}X`;
        break;
      case PaymentType.TWO_CREDIT_CARDS:
        s = `Dois cartões ${installments}X`;
        break;
      case PaymentType.DEBIT_CARD:
        s = 'Débito';
        break;
      case PaymentType.PIX:
        s = 'PIX';
        break;
      case PaymentType.BANK_SLIP:
        s = 'Boleto';
        break;
      case PaymentType.MONEY:
        s = 'Dinheiro';
        break;
      default:
        s = '';
        break;
    }
    return s;
  };
  const mountDataColumnPaymentType = (payments: OrderPayment[]): DataColumn[] => {
    const dataColumnProfiles: DataColumn[] = [];
    if (payments && payments.length > 0) {
      payments.forEach((data, index) => {
        dataColumnProfiles.push({
          id: String(index),
          name: fromPaymentType(data.paymentType, data.installments),
        });
      });
    }
    return dataColumnProfiles;
  };
  const mountDataColumnTransaction = (payments: OrderPayment[]): DataColumn[] => {
    const dataColumnProfiles: DataColumn[] = [];
    if (payments && payments.length > 0) {
      payments.forEach((data, index) => {
        dataColumnProfiles.push({
          id: String(index),
          name: data.transaction,
        });
      });
    }
    return dataColumnProfiles;
  };
  const handleSharePdf = async (pdfUrl: string): Promise<void> => {
    if (navigator.share) {
      try {
        await navigator.share({
          title: 'Ingresso PDF',
          text: 'Segue link do seu ingresso:',
          url: pdfUrl,
        });
        toast.success('Compartilhado com sucesso!');
      } catch (error) {
        // Fallback for cancellation/error
        const waUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
          `Segue o link do seu ingresso: ${pdfUrl}`,
        )}`;
        window.open(waUrl, '_blank');
      }
    } else {
      const waUrl = `https://api.whatsapp.com/send?text=${encodeURIComponent(
        `Segue o link do seu ingresso: ${pdfUrl}`,
      )}`;
      window.open(waUrl, '_blank');
    }
  };

  const dataTableTicket = listTickets?.map(item => {
    const ticketIdStr = item.id || item.orderItemId;
    return {
      id: (
        <div className="d-flex align-items-center" style={{ gap: '6px' }}>
          <span style={{ fontSize: '12px', opacity: 0.8 }} title={ticketIdStr}>
            {ticketIdStr}
          </span>
          <button
            onClick={e => {
              e.stopPropagation();
              navigator.clipboard.writeText(ticketIdStr);
              toast.success('ID copiado!');
            }}
            style={{
              background: 'none',
              border: 'none',
              padding: 0,
              cursor: 'pointer',
              display: 'inline-flex',
              alignItems: 'center',
            }}
            title="Copiar ID"
          >
            <Copy size={14} color="#3CAFC8" />
          </button>
        </div>
      ),
      pdvName: item.pdvName,
      sectionAndTicket: item.ticketId
        ? `${item.sectionName} - ${item.isHalfPrice ? 'Meia' : 'Inteira'}`
        : item.sectionName,
      cpf: updateMaskCPF(item.clientCPF),
      saleDate: dayjs(item.saleDate).locale('pt-br').format('DD/MM/YYYY [às] HH:mm'),
      paymentStatus:
        item.ticketStatus === StatusType.EXCLUDED
          ? fromStatusType(item.ticketStatus)
          : fromPaymentStatus(item.orderPaymentStatus),
      saleValue: formatValueToCurrency(`${item.saleValue}`).masked,
      paymentType:
        // eslint-disable-next-line no-nested-ternary
        item.payments && item.payments.length > 1 ? (
          <DropdonwFlags
            pointerClass={true}
            dataColumn={mountDataColumnPaymentType(item.payments)}
          />
        ) : item.payments && item.payments.length === 1 ? (
          fromPaymentType(item.payments[0].paymentType, item.payments[0].installments)
        ) : (
          ''
        ),
      transaction:
        // eslint-disable-next-line no-nested-ternary
        item.payments && item.payments.length > 1 ? (
          <DropdonwFlags
            pointerClass={true}
            dataColumn={mountDataColumnTransaction(item.payments)}
          />
        ) : item.payments && item.payments.length === 1 ? (
          item.payments[0].transaction
        ) : (
          ''
        ),

      actions: (
        <React.Fragment>
          {/*
          <Transfer
            className={getClassName(item.reverseDate !== null)}
            onClick={e =>
              item.cancelDate === null ? onShowReversePayment(item) : e.stopPropagation()
            }
          />
           */}
          {item.comments && item.comments.length > 0 && (
            <span
              className="badge badge-custom position-absolute top-0 start-100 translate-middle rounded-pill bg-danger"
              style={{ marginLeft: '12px' }}
            >
              {item.comments.length}
            </span>
          )}
          <Comment
            className={getClassName(item.comments && item.comments.length > 0)}
            onClick={(): void =>
              onShouldShowModal({
                value: ShouldShowModal.comment,
                newTitleModal: 'Comentários',
                orderTicket: item,
              })
            }
          />
          <Detail
            className={'mr-4 svg-icon action-icon'}
            onClick={() =>
              onShouldShowModal({
                value: ShouldShowModal.detail,
                newTitleModal: 'Ver dados',
                orderTicket: item,
              })
            }
          />
          {item.pdfUrl && (
            <FaFilePdf
              className="mr-4 svg-icon action-icon"
              style={{
                color: '#3CAFC8',
                fontSize: '18px',
                cursor: 'pointer',
                verticalAlign: 'middle',
              }}
              title="Compartilhar PDF"
              onClick={() => handleSharePdf(item.pdfUrl || '')}
            />
          )}
          {item.qrCode && (
            <FaQrcode
              className="mr-4 svg-icon action-icon"
              style={{
                color: '#3CAFC8',
                fontSize: '18px',
                cursor: 'pointer',
                verticalAlign: 'middle',
              }}
              title="Visualizar QR Code"
              onClick={() =>
                onShouldShowModal({
                  value: ShouldShowModal.qrcode,
                  newTitleModal: 'Visualizar QR Code',
                  orderTicket: item,
                })
              }
            />
          )}
          {/*
          <X
            className={getClassName(item.cancelDate !== null)}
            onClick={e => (item.cancelDate === null ? onShowCancelTicket(item) : e.stopPropagation())}
          />
           */}
        </React.Fragment>
      ),
    };
  });

  const renderActionDialogToCancel: ActionProps = {
    title: 'Cancelar',
    onClick: (): void => onToggle(),
    theme: 'noneBorder',
  };
  const renderActionDialogToFilter: ActionProps = {
    title: 'Limpar',
    onClick: (): void => clearFilter(),
    theme: 'noneBorder',
  };

  return (
    <Fragment>
      <Loading isVisible={state === States.loading} />
      <Dialog
        title={title}
        visible={visible}
        onClose={onToggle}
        position={shouldShowModal === ShouldShowModal.filter ? 'right' : 'center'}
        isContentWithCard={true}
        actions={[
          {
            [ShouldShowModal.filter]: renderActionDialogToFilter,
            [ShouldShowModal.comment]: renderActionDialogToCancel,
            [ShouldShowModal.detail]: renderActionDialogToCancel,
            [ShouldShowModal.qrcode]: renderActionDialogToCancel,
          }[shouldShowModal],
          {
            [ShouldShowModal.filter]: {
              title: 'Filtrar',
              onClick: (): Promise<void> => onFilter(),
            },
            [ShouldShowModal.comment]: {
              title: 'Publicar',
              onClick: (): Promise<void> => controllerComment.onAdd(),
              disabled: controllerComment.formData.comment === '',
            },
            [ShouldShowModal.detail]: {
              title: 'OK',
            },
            [ShouldShowModal.qrcode]: {
              title: 'OK',
            },
          }[shouldShowModal],
        ]}
      >
        {
          {
            [ShouldShowModal.filter]: (
              <FilterContent
                formData={formDataFilter}
                formErrors={formErrorsFilter}
                onChangeFormInput={onChangeFormInputFilter}
              />
            ),
            [ShouldShowModal.comment]: (
              <RegisterCommentContent
                formData={controllerComment.formData}
                formErrors={controllerComment.formErrors}
                comments={controllerComment.comments}
                onChangeFormInput={controllerComment.onChange}
              />
            ),
            [ShouldShowModal.detail]: (
              <TicketDetailContent detail={ticketDetail} orderTicket={orderTicket} />
            ),
            [ShouldShowModal.qrcode]: (
              <div className="d-flex flex-column align-items-center justify-content-center p-4">
                {orderTicket?.qrCode ? (
                  <>
                    <div
                      style={{
                        background: 'white',
                        padding: '16px',
                        borderRadius: '8px',
                        border: '1px solid #ddd',
                      }}
                    >
                      <QRCode value={orderTicket.qrCode} size={200} />
                    </div>
                    <div
                      className="mt-3 text-center text-muted"
                      style={{
                        fontSize: '12px',
                        maxWidth: '280px',
                        wordBreak: 'break-all',
                        fontFamily: 'monospace',
                      }}
                    >
                      {orderTicket.qrCode}
                    </div>
                    <button
                      className="btn btn-sm mt-3"
                      style={{ backgroundColor: '#3CAFC8', borderColor: '#3CAFC8', color: '#fff' }}
                      onClick={() => {
                        navigator.clipboard.writeText(orderTicket.qrCode || '');
                        toast.success('Token do QR Code copiado!');
                      }}
                    >
                      Copiar Token
                    </button>
                  </>
                ) : (
                  <div>QR Code indisponível</div>
                )}
              </div>
            ),
          }[shouldShowModal]
        }
      </Dialog>

      <Container className="mainContainer" fluid={true}>
        <div className="d-flex justify-content-between" style={{ paddingBottom: '30px' }}>
          <div className="pageTitle" style={{ display: 'grid' }}>
            <div className="d-flex">
              <Link to={`${process.env.PUBLIC_URL}/dashboard/event`}>
                <ArrowLeft color={colors.black} className="arrow-left mr-3" />
              </Link>
              <Label>Gestão de ingressos - {event?.name}</Label>
            </div>
          </div>
          <div className="button-filter-container">
            <div className="filter-container">
              <div
                className="filter-content"
                onClick={(): void => {
                  onToggle();
                  onShouldShowModal({
                    value: ShouldShowModal.filter,
                    newTitleModal: '',
                  });
                }}
              >
                <FilterVector />
              </div>
            </div>
          </div>
        </div>
        <CustomTable
          columns={columns}
          data={dataTableTicket}
          numberRowsPerPage={currentPage.pageSize}
          progressPending={state === States.loading}
          theme="primaryWithMargin"
        />
        <Pagination
          currentPage={currentPage.page}
          totalCount={currentPage.total}
          pageSize={currentPage.pageSize}
          onPageChange={page => onPaginationChange(page)}
          total={currentPage.total}
        />
      </Container>
    </Fragment>
  );
};
